import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HostnameService } from '@services/hostname.service';
import { map } from 'rxjs/operators';
import { cleanupContextualTools } from '@utils/contextual-tool-cleanup';

@Injectable()
export class LayersAPIService {
  baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    private hostnameService: HostnameService
  ) {
    this.baseUrl = this.hostnameService.getOrigin();
  }

  getTileCards(rid) {
    rid = rid.replace('#', '');
    return this.httpClient.get(`${this.baseUrl}/api/v1/cards/rids?rids=${rid}`);
  }
  apiPassthrough(endpoint, method, payload?: any) {
    const url = endpoint.startsWith('/') ? `/api/v1${endpoint}` : `/api/v1/${endpoint}`;
    return this.httpClient[method](this.baseUrl + url, payload);
  }

  getSidepanelDetails(rid, layer, mattermaps) {
    return this.httpClient
      .get(`${this.baseUrl}/api/v1/info/${rid}?layer=${layer}&module=${mattermaps}&is_new_formschema=true`)
      .pipe(
        map((response: any) => {
          if (response?.contextualTools?.length) {
            response.contextualTools = cleanupContextualTools(response.contextualTools);
          }
          return response;
        })
      );
  }
}
